import {React, ReactDOM, showModal, hideModal, LEVEL_DIALOG, extend, _n} from 'pexui';
import * as utils from '../utilities/utils';
import {Button} from './comps/uicomps';
import {Html} from './comps/html';
const Promise = utils.Promise;

export function showModalPromise(comp, level){
    return new Promise((resolve, reject)=>{
        const oldOnClose = comp.props.onClose;
        comp.props.onClose = (val)=>{
            if(typeof oldOnClose === 'function'){
                oldOnClose(val);
            }

            resolve(val);
        };

        showModal(comp, level);
    }); // triggering the promise
}

/**
 * props:{
 *   id:    elem_id,
 *   className: styles class,
 *   style: style object,
 *   title: string,
 *   closeAction: string (the choice string to send back),
 *   onClose: a callback of function (choice)
 *   message: string,
 *   buttons: [{
 *      label: 'OK',
 *      isPrimary: true/false,
 *      value: 'ok'
 *   }]
 * }
 */
export class Dialog extends React.Component {
    constructor(props){
        props.onClose = props.onClose || props.onSelect; // compatible to old interface
        props.className = props.className || "infw-dialog-frame";
        props.style = props.style || {};
        
        if(props.width){
            const buttons = props.buttons || [];
            const maxLabelLen = utils.reduceArray(buttons, (maxlen, button)=>Math.max((button.label || '').length, maxlen), 0);
            if(maxLabelLen > 10){
                props.width += 50;
            }

            props.style.width = props.width + 'px';
        }
        if(props.height){
            props.style.height = props.height + 'px';
        }

        super(props);
        this.value = null;
        this.level = this.props.level || LEVEL_DIALOG;
    }

    show(){
        return showModalPromise(this, this.level);
    }

    closeDialog(){
        hideModal(this.level);

        if(typeof this.props.onClose === 'function'){
            this.props.onClose(this.value);
        }
    }

    onButtonClick(value){
        this.value = value;
        this.closeDialog();
    }

    renderCaption(){
      const captionBarCloseButton = this.props.closeAction ?
            <div className="infw-icon-close-holder">
                <span id="infw_icon_dlg_close"
                    className="infw-icon-close"
                    onClick={() => this.onButtonClick(this.props.closeAction)}
                />
            </div>
            : '';

      //style={{ 'font-family':'BentonSans', color: '#002663','font-size': '1.5rem'}}
      if(this.props.title || this.props.closeAction){
          return <div className="infw-dialog-title-bar">
                <div className="infw-dialog-title" >{this.props.title || ' '}</div>
                {captionBarCloseButton}
             </div>;
      }else{
          return '';
      }
    }

    renderBody(){
        const content = [];
        if(this.props.icon){
            content.push(<div className="infw-dialog-icons" id="infw-dialog-icons">
                            <span className={this.props.icon}></span>
                        </div>);
        }

        if(this.props.subTitle){
            content.push(<Html className="infw-dialog-subtitle" id="infw-dialog-subtitle" content={this.props.subTitle}/>);
        }

        if(this.props.message){
            content.push(<Html className="infw-dialog-text" id="infw-dialog-text" content={this.props.message}/>);
        }

        return <div className="infw-dialog-body" role="dialog" aria-labelledby="infw-dialog-subtitle infw-dialog-text infw-dialog-icons">
                   {content}
               </div>;
    }

    renderButtons(){
        const buttons = this.props.buttons || [];
        const maxLabelLen = utils.reduceArray(buttons, (maxlen, button)=>Math.max((button.label || '').length, maxlen), 0);
        const smallButton = maxLabelLen < 10;
        let buttonLayout;
        let className = "infw-dialog-btn-box";
        if(buttons.length > 1 && (!buttons[0].isPrimary) && buttons[1].isPrimary){
            className = className + ' infw-sm-reverse';
        } 

        if(maxLabelLen < 18){
            buttonLayout = buttons?(buttons.length === 1? 'col-md-4 col-md-offset-4': 'col-md-4 col-md-offset-1'):'';
        }else{
            buttonLayout = buttons?(buttons.length === 1? 'col-md-8 col-md-offset-2': 'col-md-6'):'';
        }
        const buttonComps = buttons.map((button)=>{
            //buttonComps.push(<div className="col-md-1"/>);
            return <div className={buttonLayout} aria-labelledby={button.id}>
                    <Button
                        id={button.id}
                        className={button.isPrimary?
                            (smallButton?'infw-btn-primary-small':'infw-btn-primary'):
                            (smallButton?'infw-btn-secondary-small': 'infw-btn-secondary')}
                        onClick={()=>this.onButtonClick(button.value)}
                        label={button.label}>
                    </Button>
                    <Html className="infw-dialog-btn-desc" content={button.desc} hideEmpty={true}/>                    
                </div>;
        });

        return <div className={className}>
                    {buttonComps}
               </div>;
    }

    renderFooter(){
        return '';
    }

    render(){
        return <div id={this.props.id}
                    className={this.props.className} aria-modal={true} role="dialog"
                    >
                 {this.renderCaption()}
                 {this.renderBody()}
                 {this.renderButtons()}
                 {this.renderFooter()}
             </div>
    }
};

export class SubmitDialog extends Dialog{
    constructor(props){
        super(extend({
            role: "dialog",
            aria: {
                labelledby: 'infw_dialog_submit',
                modal: true,
            },
            id: 'infw_dialog_submit',
            width: 600,
            height: 220,
            message: _n('submit.message'),
            icon: _n('submit.dialog.icon'),
            buttons:[
                {id:'infw_btn_dlg_no', label:_n('submit.no.label'),  isPrimary: false, value: 'no', desc: _n('submit.no.desc')},
                {id:'infw_btn_dlg_yes',label:_n('submit.yes.label'), isPrimary: true,  value: 'yes', desc: _n('submit.yes.desc')}
            ]},
            props));
    }
}

export class ConfirmDialog extends Dialog{
    constructor(props){
        super(extend({
            role: "dialog",
            aria: {
                labelledby: 'infw_dialog_confirm',
                modal: true,
            },
            id: 'infw_dialog_confirm',
            width: 500,
            height: 200,
            subTitle: _n('submit.message'),
            icon: "icon-xl infw-icon-warning",
            buttons:[
                {id:'infw_btn_dlg_no', label:_n('no'),  isPrimary: false, value: 'no'},
                {id:'infw_btn_dlg_yes',label:_n('yes'), isPrimary: true,  value: 'yes'}
            ]},
            props));

    }
}

export class ExitConfirmDialog extends ConfirmDialog{
    constructor(props){
        super(extend({
                role: "dialog",
                aria: {
                    labelledby: 'infw_dialog_exit_widget',
                    modal: true,
                },
                id: 'infw_dialog_exit_widget',
                subTitle: _n('exit.title'),
                icon: _n('exit.dialog.icon')
            }, props));
    }
}

export class ExitYodleeDialog extends Dialog{
    constructor(props){
        super(extend({
            role: "dialog",
            aria: {
                labelledby: 'infw_dialog_exit_yodlee',
                modal: true,
            },
            id: 'infw_dialog_exit_yodlee',
            width: 500,
            height: 200,
            icon:     _n('exit.yodlee.icon'),
            subTitle: _n('exit.yodlee.title'),
            message: _n('exit.yodlee.message'),
            buttons:[
                {id:'infw_btn_exit_yodlee_no', label:_n('exit.yodlee.no.label'),  isPrimary: false, value: 'no'},
                {id:'infw_btn_exit_yodlee_yes',label:_n('exit.yodlee.yes.label'), isPrimary: true,  value: 'yes'}
            ]},
            props));
    }
}

export class MessageDialog extends Dialog{
    constructor(props){
       super(extend({
            role: "dialog",
            aria: {
                labelledby: 'infw_dialog_message_box',
                modal: true,
            },
            id: 'infw_dialog_message_box',
            width: 500,
            height: 300,
            icon: _n("message.dialog.icon"),
            message: "",
            buttons:[{id:'infw_btn_dlg_ok', label:_n('button_ok.label'), isPrimary: true, value: 'ok'}]
        }, props));
    }
}

export function messageBox(message){
    const height = 180 + 20 * Math.ceil(message.length / 50);
    return showModalPromise(<MessageDialog message={message} height={height}/>);
}

export class ErrorDialog extends Dialog{
    constructor(props){
       super(extend({
            role: "dialog",
            aria: {
                labelledby: 'infw_dialog_error',
                modal: true,
            },
            id: 'infw_dialog_error',
            width: 500,
            height: 300,
            icon: _n('error.dialog.icon'),
            message: "Error",
            buttons:[{id:'infw_btn_dlg_ok', label:_n('button_ok.label'), isPrimary: true, value: 'ok'}]
        }, props));
    }
}

export function showError(err){
    err = '' + err;
    if(/^HTTP \d+/.test(err)){
        err = _n("error.service.message");
    }
    const height = 180 + 20 * Math.ceil(err.length / 50);

    return showModalPromise(<ErrorDialog message={err} height={height}/>);
}

module.exports.showModal = showModal;



// WEBPACK FOOTER //
// ./application/src/views/dialog.jsx